export default __webpack_public_path__ + "static/media/public.1b308497.less";